export const KEK = 'KEK'